import { Window } from './Window';

export class PerpendicularTriangleBottomRightWindow extends Window {
  constructor(renderer, parent, def) {
    super(renderer, parent, def);
  }

  _create2DVertices(width, height, adjust, geometryData) {
    return create2DVertices(width, height, adjust);
  }

  _transformDimensionsToRect(dimensions, width, height) {
    return transformDimensionsToRect(dimensions, width, height);
  }
}

export function transformDimensionsToRect(dimensions, width, height) {
  const angle1 = Math.atan2(height, width);
  const angle2 = Math.PI / 2 - angle1;
  const OKA = dimensions.HSP; // Top left

  let dLeft = 0;
  dLeft += dimensions.UNP * Math.tan(angle2);
  dLeft += OKA / Math.cos(angle2);

  let dTop = 0;
  dTop += dimensions.HSP * Math.tan(angle1);
  dTop += OKA / Math.cos(angle1);

  return {
    left: dLeft,
    right: dimensions.HSP,
    top: dTop,
    bottom: dimensions.UNP,
  };
}

export function create2DVertices(width, height, adjust) {
  const hw = width / 2;
  const hh = height / 2;
  const angle1 = Math.atan2(height, width);
  const angle2 = Math.PI / 2 - angle1;
  const a = adjust;
  const OKA = a.HSP; // Top left

  const l = -hw - OKA / Math.sin(angle1) - a.UNP / Math.tan(angle1); // Left
  const r = hw + a.HSP; // Right
  const t = hh + OKA / Math.sin(angle2) + a.HSP / Math.tan(angle2); // Top
  const b = -hh - a.UNP; // Bottom

  return [l, b, r, t, r, b];
}
